import { render, staticRenderFns } from "./DarkModeIcon.vue?vue&type=template&id=fb4e80ec&"
import script from "./DarkModeIcon.vue?vue&type=script&lang=js&"
export * from "./DarkModeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports